import { Card, CardBody, CardFooter, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import DashTicketsListItem from "./DashTicketsListItem";
import { Link } from "react-router-dom";

const DashTicketsList = ({tickets}) => {

    // gui
    return (
        <Card className="shadow-lg" style={{borderRadius: 15}}>
            <CardBody className="text-start">
                <p><b>Tickets</b></p>
                <ListGroup variant="flush" style={{ fontSize: 13}}>
                    {tickets && tickets.length > 0 ?
                        tickets.map(t => (
                            <DashTicketsListItem key={t.id} ticket={t} />
                        )) :
                        <ListGroupItem><span className="text-muted">Sie haben keine Tickets</span></ListGroupItem>
                    }
                </ListGroup>
            </CardBody>
            <CardFooter>
                <Row>
                    <Col xs="6" className="border-right text-center">
                        <Link to="/dashboard/support/" className="link-energo">Supportbereich</Link>
                    </Col>
                    <Col xs="6" className="text-center">
                        <Link to="/dashboard/support/neu/" className="link-energo">Neues Ticket</Link>
                    </Col>
                </Row>
            </CardFooter>
        </Card>
    )
}
export default DashTicketsList;